import { FC, ReactNode, useMemo } from 'react';

import _ from '../../../locale';
import { AiChatDataCollectionOption } from '../../../types';
import { getBestMatchDataCollectionId } from '../../../utility/ai-chat-content';
import MarkdownMessageContent from '../MarkdownMessageContent';
import DataCollectionOptions from './DataCollectionOptions';
import SelectedOption from './SelectedOption';
import { Body } from './styles';

export interface DataCollectionPickerProps {
    content?: string | null;
    options: AiChatDataCollectionOption[];
    pickedDataCollectionId?: number | null;
    isDismissed?: boolean;
    disabled?: boolean;
    onPick?: (dataCollectionId: number) => void;
    footer?: ReactNode;
}

const DataCollectionPicker: FC<DataCollectionPickerProps> = ({
    content,
    options,
    pickedDataCollectionId,
    isDismissed = false,
    disabled,
    onPick,
    footer,
}) => {
    const bestMatchId = useMemo(() => getBestMatchDataCollectionId(options), [options]);
    const settledLabel =
        options.find(({ id }) => id === pickedDataCollectionId)?.name ??
        (isDismissed ? _('dex_chat_data_collection_ask_something_else') : null);

    return (
        <Body data-testid="dex-chat-data-collection-picker">
            {content ? (
                <MarkdownMessageContent>{content}</MarkdownMessageContent>
            ) : (
                _('dex_chat_data_collection_candidates_prompt')
            )}

            {settledLabel ? (
                <SelectedOption label={settledLabel} />
            ) : (
                <DataCollectionOptions
                    options={options}
                    bestMatchId={bestMatchId}
                    disabled={disabled}
                    onPick={onPick}
                />
            )}

            {footer}
        </Body>
    );
};

export default DataCollectionPicker;
